import {
  Button,
  Card,
  CardBody,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
  Typography
} from "@material-tailwind/react";
import React, {useContext, useEffect, useRef, useState} from "react";
import "../../style/datePicker.css"
import {updateServiceFinish, updateServiceStatus} from "../../services/service/service";
import {ServiceDocumentGrid} from "./agent_service_document-grid";
import {ServiceDetailForm} from "./service_detail_form";
import {ServiceContext} from "../../context/service";
import {submitServiceVoip} from "../../services/voip/voip";
import {AgentServiceStepsGrid} from "./agent_service_step_grid";
import {getServicePaymentAndSteps} from "../../services/service/service_step";
import {AgentServiceCheckHeaderAlert} from "../alert/service/agent_service__check_header_alert";
import {AgentServiceSideCostGrid} from "./agent_service_side_cost_grid";
import {ServiceCheckDialog} from "./service_check_dialog";

const profileServiceModal = process.env.NODE_ENV !== "production";

export function AgentServiceCheckForm() {

  const {
    service,
    setService,
    modalOpen,
    setModalOpen,
    setDocument,
    lastDataRefresh,
    setLastDataRefresh,
    setStep,
    serviceSteps,
    setServiceSteps,
    setBranchInfo,
    totalDays,
    setTotalDays,
    totalSideCost,
    setTotalSideCosts,
    sideCosts,
    setSideCosts,
    show,
    setShow,
    serviceDetailCacheRef,
  } = useContext(ServiceContext);

  const handleOpen = () => {
    setModalOpen(!modalOpen);
  }

  const [allAccepted, setAllAccepted] = useState(false);

  const [serviceDocumentations, setServiceDocumentations] = useState([])
  const [loadedServiceId, setLoadedServiceId] = useState(null)
  const modalOpenedAtRef = useRef(null)

  const applyServiceDetails = (data, serviceId) => {
    const startedAt = profileServiceModal ? performance.now() : 0;
    const {
      serviceDocumentationList,
      service_agent_branch_fee_info,
      service_steps,
      service_side_costs,
    } = data;
    setServiceDocumentations(serviceDocumentationList || []);

    let documentations_accepted, steps_accepted
    if (serviceDocumentationList?.length > 0) {
      documentations_accepted = serviceDocumentationList.every(obj => obj.status === "accepted")
    } else {
      documentations_accepted = true;
    }

    if (service_steps?.length > 0) {
      steps_accepted = service_steps.every(obj => obj.days > 0)
    } else {
      steps_accepted = false;
    }

    const all_accepted = documentations_accepted && steps_accepted
    setAllAccepted(all_accepted);

    setBranchInfo(service_agent_branch_fee_info)
    setServiceSteps(service_steps)

    let total_days = 0;
    if (service_steps && Array.isArray(service_steps)) {
      total_days = service_steps.reduce((sum, step) => sum + (step.days || 0), 0);
    }

    setService(service => ({
      ...service,
      days: total_days,
    }))
    setTotalDays(total_days)

    setSideCosts(service_side_costs || [])
    let total_side_costs = 0;
    if (service_side_costs && Array.isArray(service_side_costs)) {
      total_side_costs = service_side_costs.reduce((sum, sideCost) => sum + (sideCost.cost || 0), 0);
    }

    setTotalSideCosts(total_side_costs)
    setLoadedServiceId(serviceId)

    if (profileServiceModal) {
      console.debug("[service-modal][agent] apply details", {
        serviceId,
        durationMs: Math.round(performance.now() - startedAt),
        documents: serviceDocumentationList?.length || 0,
        steps: Array.isArray(service_steps) ? service_steps.length : 0,
        sideCosts: Array.isArray(service_side_costs) ? service_side_costs.length : 0,
      });
    }
  };

  useEffect(() => {
    if (!profileServiceModal || !modalOpen || !service?.id) {
      return;
    }

    modalOpenedAtRef.current = performance.now();
    console.debug("[service-modal][agent] open", {
      serviceId: service.id,
      cached: Boolean(serviceDetailCacheRef?.current?.[service.id]),
      step: show,
    });
  }, [modalOpen, service?.id]);

  useEffect(() => {
    if (!profileServiceModal || loadedServiceId !== service?.id || !modalOpenedAtRef.current) {
      return;
    }

    console.debug("[service-modal][agent] ready", {
      serviceId: service.id,
      durationMs: Math.round(performance.now() - modalOpenedAtRef.current),
    });
  }, [loadedServiceId, service?.id]);

  useEffect(() => {
    let ignore = false;

    async function getData() {
      setServiceSteps({});
      setSideCosts({});
      const startedAt = profileServiceModal ? performance.now() : 0;
      const result = await getServicePaymentAndSteps(service.id);
      if (profileServiceModal) {
        console.debug("[service-modal][agent] getServicePaymentAndSteps", {
          serviceId: service.id,
          status: result.status,
          durationMs: Math.round(performance.now() - startedAt),
        });
      }
      if (!ignore && result.status === 200) {
        if (serviceDetailCacheRef?.current) {
          serviceDetailCacheRef.current[service.id] = result.data;
        }
        applyServiceDetails(result.data, service.id)
      }
    }

    if (service?.id) {
      const cachedDetails = serviceDetailCacheRef?.current?.[service.id];
      if (cachedDetails) {
        if (profileServiceModal) {
          console.debug("[service-modal][agent] cache hit", {serviceId: service.id});
        }
        applyServiceDetails(cachedDetails, service.id)
      }

      if (!cachedDetails || lastDataRefresh) {
        if (profileServiceModal) {
          console.debug("[service-modal][agent] cache miss/fetch", {
            serviceId: service.id,
            refresh: Boolean(lastDataRefresh),
          });
        }
        getData()
      }
    }

    return () => {
      ignore = true;
    }
  }, [service.id, lastDataRefresh]);

  const save = async () => {
    const data = {
      id: service.id,
      status: "waiting",
    };
    let result;

    result = await updateServiceStatus(data);

    if (result.status === 202) {
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  const save_finish = async () => {

    let result;

    result = await updateServiceFinish(service.id);

    if (result.status === 202) {
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  const tabs = [
    {
      value: 1,
      label: "مدارک مورد نیاز",
      content: (
        <>
          <div className="flex flex-row justify-end">
            {service.status !== "finish" &&
              <Button className="min-w-fit" onClick={() => {
                setDocument(null);
                setStep("documentation");
              }} variant="outlined">
                جدید
              </Button>
            }
          </div>

          <ServiceDocumentGrid setAllAccepted={setAllAccepted}
                               serviceDocuments={serviceDocumentations}
          />
        </>
      ),
    },
    {
      value: 2,
      label: "مراحل انجام خدمت",
      content: (
        <div className="flex flex-col justify-center max-w-full overflow-x-auto">
          {serviceSteps?.length > 0 &&
            <AgentServiceStepsGrid/>
          }
        </div>
      ),
    },
    {
      value: 3,
      label: "هزینه های دولتی و جانبی",
      content: (
        <>
          <div className="flex flex-row justify-end">
            {service.status === "new" &&
              <Button className="min-w-fit" onClick={() => {
                setStep("side_cost");
              }} variant="outlined">
                جدید
              </Button>
            }
          </div>
          <div className="flex flex-col justify-center max-w-full overflow-x-auto">
            {sideCosts?.length > 0 &&
              <AgentServiceSideCostGrid/>
            }
          </div>
        </>
      ),
    },
    {
      value: 4,
      label: "قیمت گذاری و اطلاعات خدمات",
      content: <ServiceDetailForm/>,
    },
  ];
  const activeTab = tabs.some(tab => tab.value === show) ? show : tabs[0].value;
  const detailsLoaded = loadedServiceId === service.id;

  return (<>
    <ServiceCheckDialog
      open={modalOpen}
      onClose={handleOpen}
      className="max-h-screen overflow-y-scroll"
    >
      <DialogHeader className="border-b">
        <Typography>
          {"درخواست خدمات" + " - " + service.person_name + " " + service.person_family + " - " + service.field_title + " " + service.branch_title}
        </Typography>
      </DialogHeader>
      <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

        <AgentServiceCheckHeaderAlert/>

        <Button
          variant="outlined"
          className="justify-start textCenter max-w-[120px]"
          onClick={() => {
            const data = {service_id: service.id,};
            submitServiceVoip(data);
          }}
        >
          تماس با کاربر
        </Button>

        {!detailsLoaded &&
          <Typography color="blue-gray" className="text-center py-8">
            در حال دریافت اطلاعات...
          </Typography>
        }

        {detailsLoaded &&
          <Card>
          <CardBody className="flex flex-col p-3 md:p-5">
            <Tabs value={activeTab} className="w-full">
              <TabsHeader
                className="w-full overflow-x-auto rounded-md bg-blue-gray-50 p-1"
                indicatorProps={{
                  className: "bg-white shadow-sm rounded-md",
                }}
              >
                {tabs.map(({value, label}) => (
                  <Tab
                    key={value}
                    value={value}
                    onClick={() => setShow(value)}
                    className="min-w-fit px-4 py-2 text-sm md:text-base"
                  >
                    {label}
                  </Tab>
                ))}
              </TabsHeader>
              <TabsBody
                className="mt-4 rounded-md border border-blue-gray-100 bg-white"
                animate={{
                  initial: {opacity: 0},
                  mount: {opacity: 1},
                  unmount: {opacity: 0},
                }}
              >
                {tabs.filter(({value}) => value === activeTab).map(({value, content}) => (
                  <TabPanel key={value} value={value} className="p-3 md:p-4">
                    {content}
                  </TabPanel>
                ))}
              </TabsBody>
            </Tabs>
          </CardBody>
        </Card>
        }

      </DialogBody>

      {service.status !== "finish" &&
        <DialogFooter className="space-x-2 mb-4">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>بستن</span>
          </Button>
          {detailsLoaded && service.price && service.price > 0 && service.status !== "payment" && service.status !== "waiting" && service.status !== "second_waiting" &&
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>تایید جهت پرداخت</span>
            </Button>
          }
          {/*{service.price && service.price > 0 && service.day > 0 && allAccepted === false && service.status !== "payment" &&*/}
          {/*  <Button variant="gradient" color="gray" onClick={save} className="ml-1" disabled={true}>*/}
          {/*    <span>در انتظار بررسی مدارک</span>*/}
          {/*  </Button>*/}
          {/*}*/}
          {/*{service.price && service.price > 0 && service.day > 0 && allAccepted && service.status === "payment" &&*/}
          {/*  <Button variant="gradient" color="gray" onClick={save_finish} className="ml-1">*/}
          {/*    <span>اتمام خدمات</span>*/}
          {/*  </Button>}*/}
        </DialogFooter>}
    </ServiceCheckDialog>
  </>);
}
